/** The uploads dialog's footprint, shared with the dialogs that should open at the same size as it. */
export const UPLOADS_MODAL_HEIGHT = '94%';
export const UPLOADS_MODAL_MOBILE_HEIGHT = '800px';

/** The Brand Kits mobile handoff's sheet fills 561 of the phone's 640px, leaving the page peeking above it. */
const BRAND_KIT_PICKER_SHEET_SCREEN_SHARE = 561 / 640;

/** The bottom sheet's height in px when a brand kit opens the picker on a phone: the handoff's share of the screen. */
export const getBrandKitPickerMobileHeight = (windowHeight: number): number => {
  return Math.round(windowHeight * BRAND_KIT_PICKER_SHEET_SCREEN_SHARE);
};

const WIDE_WINDOW_MIN_WIDTH = 2000;
const PHONE_WINDOW_MAX_WIDTH = 550;

export const getUploadsModalWidth = (windowWidth: number): string => {
  if (windowWidth > WIDE_WINDOW_MIN_WIDTH) {
    return '1600px';
  }

  if (windowWidth > PHONE_WINDOW_MAX_WIDTH) {
    return '80%';
  }

  return '600px';
};
